const GiftMessage = (props) => {
  const { clubMembership } = props;
  if (!clubMembership.giftMessage || clubMembership.giftMessage === '') {
    return null;
  }
  return (
    <div className="c7-order__customer-detail">
      <h4>Gift Message</h4>
      <p>{clubMembership.giftMessage}</p>
    </div>
  );
};

export default GiftMessage;
